<template>
  <v-layout class="mt-4" justify-center>
    <v-flex xs8>
      <v-card class="tabs_style">
        <v-tabs centered color="primary" dark text grow>
          <v-tabs-slider color="secondary"></v-tabs-slider>

          <v-tab href="#tab-1" class="text-capitalize">
            Sales and Fees overview
          </v-tab>
          <v-tab href="#tab-2" class="text-capitalize">
            Partner fees configuration
          </v-tab>

          <v-tab-item  v-for="i in tabsNumber" :key="i" :value="'tab-' + i" justify-center>
            <v-container grid-list-xl text-xs-center>
              <Financial-Sales v-if="i==1" class="tab_container"/>
              <PartnerFees v-if="i==2" class="tab_container" />
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import * as dssRequest from "@/api/dssRequest";
import appConfig from "../../../config/app_config";
import BaseObject from "@/objects/BaseObject";
import Financial_Sales from "./Financial_Sales";
import _ from "lodash";
import { mapGetters } from "vuex";
import PartnerFees from './Financial_PartnerFees.vue';

export default {
  name: "Financial_Main",
  components: {
    "Financial-Sales": Financial_Sales,
    PartnerFees,
  },
  data() {
    return {
      partnerActive: false,
      tabsNumber: 2,
    };
  },
  beforeDestroy() {
    let page = "Financial_Main";
    this.$store.commit("setCurrentComponent", page);
  },
  mounted() {
  },
};
</script>

<style lang="scss", scoped>

.tab_container {
  height: 70vh;
  overflow-x: hidden;
  overflow-y: auto;
}
.tabs_style {
  border-radius: 2em;
}
</style>
